import React from "react";

import { Box, Button, Card, Dialog, Grid, Typography } from '@mui/material';
import { TCInput, TCSelect } from "components/TopCourtComponents/Input/TopCourtInput";
import { getPlayers } from "services/playerServices";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import { orderStatusOption, orderTypeOption, trueFalseOptions } from "constant/constant";
import NumberRangeInput from "components/TopCourtComponents/Input/NominalRangeFilter";
import { isNumericOrEmpty } from "helper/String";

export default function PackageFilter({
    filter,
    onChangeFilter,
    clearFilter
}) {
    return (
        <Card sx={{ mb: 1 }}
            className="custom-card-style">
            <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Grid container columnSpacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                        <TCInput placeHolder="Name" onChange={(e) => onChangeFilter({ name: e.currentTarget.value })} value={filter.name} label={"Package Name"} />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <NumberRangeInput
                            showLabel={true}
                            label={"Session"}
                            placeholderStart={'Min'}
                            placeholderEnd={'Max'}
                            allowZero={false}
                            numberRangeType={filter.sessionType}
                            start={filter.sessionStart}
                            end={filter.sessionEnd}
                            onChangeSelect={(e) => onChangeFilter({ sessionType: e })}
                            onChangeStart={(e) => {
                                let sessionStart = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(sessionStart)) return;
                                if (sessionStart === filter.sessionStart) return;
                                onChangeFilter({ sessionStart: sessionStart })}
                            }
                            onChangeEnd={(e) => {
                                let sessionEnd = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(sessionEnd)) return;
                                if (sessionEnd === filter.sessionEnd) return;
                                onChangeFilter({ sessionEnd: sessionEnd })}
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <NumberRangeInput
                            showLabel={true}
                            label={"Price"}
                            placeholderStart={'Min'}
                            placeholderEnd={'Max'}
                            allowZero={false}
                            numberRangeType={filter.priceType}
                            start={filter.priceStart}
                            end={filter.priceEnd}
                            onChangeSelect={(e) => onChangeFilter({ priceType: e })}
                            onChangeStart={(e) => {
                                let priceStart = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(priceStart)) return;
                                if (priceStart === filter.priceStart) return;
                                onChangeFilter({ priceStart: priceStart })}
                            } 
                            onChangeEnd={(e) => {
                                let priceEnd = e.replace(/[^0-9]/g, "");
                                if (!isNumericOrEmpty(priceEnd)) return;
                                if (priceEnd === filter.priceEnd) return;
                                onChangeFilter({ priceEnd: priceEnd })}
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                        <TCSelect
                            label={"Active"}
                            options={trueFalseOptions}
                            value={filter.isActive}
                            onChange={(e) => {
                                onChangeFilter({
                                    isActive: e
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2} sx={{ mb: 1, textAlign:'right' }} >
                        <Button sx={{mt: 2, border: '0.5px solid #2196f3', borderRadius: 4}}
                            onClick={clearFilter}
                        >Clear</Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    )
}